import type { FileUsage } from '@vedalib/editor/lib/files'
import React from 'react'
import { chainName, FileTypeEnum } from 'utils'

import { genElementValueField } from 'components/Editor/Toolbar/NodeForm/genElementValueField'
import Padding from 'components/Editor/Toolbar/Padding'
import { FieldColorPicker, FieldFile, FieldSegmented, FormField } from 'components/formKit'
import { useBrandColorOptions } from 'services/Branding/fieldConfigs/useFieldConfigs'
import { t } from 'services/Translation'

import type { ImageFormValueType } from './imageTypes'

const IMAGE = genElementValueField({
  as: FieldFile<FileUsage>,
  name: 'image',
  props: {
    fileType: FileTypeEnum.IMAGE,
    nullable: true,
    preview: true,
    showSource: true,
    hasAccessibility: true,
  },
})

const ZOOMABLE = genElementValueField({
  as: FieldSegmented<boolean>,
  name: 'zoomable',
  label: t('elements.image.form.zoomable'),
  defaultValue: false,
})

const OVERLAY = genElementValueField({
  as: FieldColorPicker<string | null>,
  name: 'overlay',
  label: t('input.label.overlay'),
  defaultValue: null,
  props: { labeled: true, resettable: true },
  useConfigs: [useBrandColorOptions],
})

const ImageElForm: ImageFormValueType = ({ name }) => {
  return (
    <Padding bottom gap sides>
      <FormField config={chainName(name, IMAGE)} />
      <FormField config={chainName(name, ZOOMABLE)} />
      <FormField config={chainName(name, OVERLAY)} />
    </Padding>
  )
}

export default React.memo(ImageElForm) as typeof ImageElForm
